module.exports = __webpack_public_path__ + "static/5-96193e007e6dcded61a49acc47e43aa3.jpeg";